module.exports = __webpack_public_path__ + "img/img34.a3c4d49c.png";